/*!
* @cc_on
* 
* Version: IWEB-3.3.13
* Built: 2021-04-01 14:41:50
* Revision: 93486
* 
* @cc_on
*/

// Fix for undefined console in IE
if (!window.console) {
    this.console = {log: function() {}, info: function() {}, error: function() {}, warn: function() {}};
}else if(typeof window.console.dir === 'undefined'){
    window.console.dir = function(){};
}else if (typeof window.console.time === 'undefined') {
    (function() {
        var timers = {};
        window.console.time = function(name) {
            timers[name] = (new Date).getTime();
        };
        window.console.timeEnd = function(name) {
            console.log('%s: %sms', name, (new Date).getTime() - timers[name]);
        };
    })();
}

/**
 * Mini ressources CSS and JS asynchrone loader
 *
 * Actually, it's used to load the extra ressources for mobile if detected
 **/
var requireLite = function(paths, id, callback) {

     //overloading checking
     id = typeof arguments[1] === "string" ? arguments[1] : "";
     callback = (typeof arguments[1] === "function" ? arguments[1] : (arguments.length === 3) ? arguments[2] : function(){});

    // Inspiration code took on HEMANTH's web site, please visit the link for more info : http://h3manth.com/content/asynchronous-loading-css-and-javascript
    // regular expression take the path and return the filename only without the rest (eg. /css/public/tablets.min.css => tablets)
    var type =/^(.+)(\.[^ .]+)?$/.exec(paths.replace(/(\?.*)|(#.*)/, "").split('.').pop() )[0],
        js, css, first, d = window.document;

    switch( type ){

        case 'js':
            first = d.getElementsByTagName('script')[0];
            js = document.createElement('script');
            js.src = paths;
            js.async = true;
            js.id = id || "";
            type = js;
            break;

        case 'css':
            first = d.getElementsByTagName('link')[0];
            css = document.createElement('link');
            css.href= paths;
            css.rel='stylesheet';
            css.id = id || "";
            type = css;
            break;
        default :
            return;
    }

    if(!callback.done && type.addEventListener){

        //w3c + IE9 and up
        callback.done = true;
        type.addEventListener("load", callback, false);

    }else if(!callback.done && type.readyState){

        //IE Legacy
        type.onreadystatechange = function(){

            if(/loaded|complete/.test(type.readyState)){
                callback.done = true;
                type.onreadystatechange = null;
                callback();
            }
        }
    }

    first.parentNode.insertBefore( type, first );
};

"use strict";

/**********************************
 * common.js
 * - utilities functions
 * */

var illicoweb = window.illicoweb || {};


//regular expressions: validating input fields with ng-pattern (ie.: search forms)
var COMMON_REGEX = {
        letter: /^[a-zA-Z]+$/,
        number: /^[0-9]+$/,
        decimal: /\d/,
        length2: /^[\sa-zA-Z0-9'\"\.,-]{2,}$/,
        length4: /^[\sa-zA-Z0-9'\"\.,-]{4,}$/,
        capitalized: /^[a-z]/,
        protDelimiter: /:\/\//,//protocol pattern delimiter '://'
        protRelativeDelimiter: /\/\//,//relative protocol pattern delimiter '//'
        wordObj: /\S+/g//return an obj of words in a string (space delimiter between word) - match
    },
    COMMON_LANG = {
        fr: "fr",
        en: "en",
        all: "all",
        original: "original"
    },
    COMMON_LIGHTBOX = {
        types: {
            avatarList: 'avatarList',
            profileRemove: 'profileRemove',
            profileListLightBox: 'profileListLightBox'
        },
        position: {
            left: 'left',
            right: 'right',
            top: 'top',
            bottom: 'bottom'
        },
        align: {
            left: 'left',
            right: 'right',
            top: 'top',
            bottom: 'bottom',
            center: 'center'
        }
    };

/**
 *  Module of detection browser performance  ( version emorization )
 */
illicoweb.browser = (function(){
    var obj = {
        COOKIE: "illico-browser",
        name: undefined,
        /**
         * Detecting IE8 and earliest version!
         * @return {boolean}
         */
        isIE8OrLess : function(){
            return (function(my){
                my.cache = my.cache || {};
                return ( ( my.cache.hasOwnProperty("value") ) ? my.cache.value : (my.cache['value'] = !!((window.attachEvent && !window.addEventListener) && !window.opera) ) );
            }(this.isIE8OrLess));
        },
        /**
         * Detecting old Firefox versions!
         * @return {boolean}
         */
        isOldFF : function(){
            return (function(my){
                my.cache = my.cache || {};
                function detectFFversion(){
                    if (navigator.appName == 'Netscape'){
                        // example userAgent "Mozilla/5.0 (Windows NT 6.1; WOW64; rv:19.0) Gecko/20100101 Firefox/19.0"
                        var re  = new RegExp(/Firefox\/([\d\.]*)$/i);
                        var rev = re.exec(navigator.userAgent);
                        var MIN_FF_VERSION = 20;
                        return (rev && rev.length > 0 && parseFloat(rev[1]) <= MIN_FF_VERSION)
                    }
                }
                return (
                    ( my.cache.hasOwnProperty("value") ) ? my.cache.value : (my.cache['value'] = detectFFversion())
                );
            }(this.isOldFF));
        },
        /**
         * Detecting IE10 only!
         * @return {boolean}
         */
        isIE10 : function(){
            return (function(my){
                my.cache = my.cache || {};

                var checkIE10Version = function(){

//                   return document.documentMode === 10;
                   return document.documentMode === 10 ? true : false;

                };

                return ( ( my.cache.hasOwnProperty("value") ) ? my.cache.value : (my.cache['value'] = checkIE10Version() ) );
            }(this.isIE10));
        },
        /**
         * Detecting IE11 only!
         * Source : http://stackoverflow.com/questions/17907445/how-to-detect-ie11
         * @return {boolean}
         */
        isIE11 : function(){
            return (function(my){
                my.cache = my.cache || {};

                var checkIE11Version = function(){
                    var rv = -1,
                        ua,
                        re;

                    if (navigator.appName == 'Microsoft Internet Explorer')
                    {
                        ua = navigator.userAgent;
                        re  = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
                        if (re.exec(ua) != null)
                            rv = parseFloat( RegExp.$1 );
                    }
                    else if (navigator.appName == 'Netscape')
                    {
                        ua = navigator.userAgent;
                        re  = new RegExp("Trident/.*rv:([0-9]{1,}[\.0-9]{0,})");
                        if (re.exec(ua) != null)
                            rv = parseFloat( RegExp.$1 );
                    }
//                    return !!((rv === 11 && document.documentMode === 11));
                    return ( rv === 11 && document.documentMode === 11 ) ? true : false;
                };

                return ( ( my.cache.hasOwnProperty("value") ) ? my.cache.value : (my.cache['value'] = checkIE11Version() ) );

            }(this.isIE11));
        },
        /**
         * Detect whether its touchable device or not.
         * @return {boolean}
         */
        isTouchDevice : function(){
            return (function(my){
                my.cache = my.cache || {};
//                return ( ( my.cache.hasOwnProperty("value") ) ? my.cache.value : (my.cache['value'] = ('ontouchstart' in document.documentElement) || (('msMaxTouchPoints' in navigator) ?  (navigator.msMaxTouchPoints >= 1)) ) );
                return ( ( my.cache.hasOwnProperty("value") ) ? my.cache.value : (my.cache['value'] = ('ontouchstart' in document.documentElement) || (('msMaxTouchPoints' in navigator) ?  ( navigator.msMaxTouchPoints >= 1 ? true : false) : false) ) );
            }(this.isTouchDevice));
        },
        /**
         * Detect whether its BlackBerry browser or not.
         * @return {boolean}
         */
        isPlayBook : function(){
            return (function(my){
                my.cache = my.cache || {};
                return ( ( my.cache.hasOwnProperty("value") ) ? my.cache.value : (my.cache['value'] = ( /playbook/i.test(navigator.userAgent.toLowerCase() ) ) ) );
            }(this.isPlayBook));
        },
        /**
         * Analyze the request's UserAgent header to figure out if the user is on a tablet device.
         * @return {string} the response will have one of the following values : 'android', 'ipad', undefined (for non-tablet devices)
         */
        getTabletType : function(){
            return (function(my){
                my.cache = my.cache || {};

                return ( ( my.cache.hasOwnProperty("value") ) ? my.cache.value : (my.cache['value'] = (function(){ var navUA = navigator.userAgent.toLowerCase(); return navUA.match(/android/i) || navUA.match(/ipad/i) ? (navUA.match(/android/i) ? 'android' : 'ipad') : undefined; }()) ) );
            }(this.getTabletType));
        }
    };

    return obj;
}());

/**
 *  Module for language internationalization
 * */
illicoweb.locale = (function(){
    var setLocale = function(userLang){
        var userLang = userLang.substring(0,2);

        if("localStorage" in window){
            window.localStorage.setItem("lang", userLang);
        }else{
            illicoweb.cookie.setter2("illico", "lang", userLang);
        }
    };

    //check language, add _US or _CA in accordance the language value
    var arrangeLocale = function( userLang ){
        userLang = (typeof userLang !== "undefined")? userLang : this.detectLocale();

        function setlocale (lang){

            if(lang.substr(0, 2) === COMMON_LANG.en){
                lang+="_US";
            }else if(userLang.substr(0, 2) === COMMON_LANG.fr){
                lang+="_CA";
            }else{
                lang = "fr_CA"; //par defaut
            }
            return lang;
        }

        if(userLang.length === 2){
            userLang = setlocale(userLang);
        }else{
            userLang = setlocale(userLang.split("_")[0]);
        }

        return userLang;
    };

    //detech language from broswer api
    var detectLocale = function(){
        var userLang;

        //check cookie
        if(("localStorage" in window) && window.localStorage.getItem("lang") != null){
            userLang = window.localStorage.getItem("lang");
        }else if(illicoweb.cookie.getter2("illico", "lang") != null){
            userLang = illicoweb.cookie.getter2("illico", "lang");
        } else {
            userLang = window.navigator.language || window.navigator.userLanguage;
            setLocale(userLang);
        }

        return userLang.substr(0, 2);
    };

    return {
        arrangeLocale: arrangeLocale,
        detectLocale: detectLocale,
        setLocale: setLocale
    }
}());

/**
 * Mini ressources CSS and JS asynchrone loader
 *
 * Actually, it's used to load the extra ressources for mobile if detected
 **/
illicoweb.requireLite = function(paths, callback) {
    //overloading checking
    var id = typeof arguments[1] === "string" ? arguments[1] : "";
    callback = (typeof arguments[1] === "function" ? arguments[1] : (arguments.length === 3) ? arguments[2] : function(){});

    // Inspiration code took on HEMANTH's web site, please visit the link for more info : http://h3manth.com/content/asynchronous-loading-css-and-javascript
    // regular expression take the path and return the filename only without the rest (eg. /css/public/tablets.min.css => tablets)
    var type =/^(.+)(\.[^ .]+)?$/.exec(paths.replace(/(\?.*)|(#.*)/, "").split('.').pop() )[0],
        js, css, first, d = window.document;

    switch(type) {
        case 'js':
            first = d.getElementsByTagName('script')[0];
            js = document.createElement('script');
            js.src = paths;
            js.async = true;
            js.id = id || "";
            type = js;
            break;
        case 'css':
            first = d.getElementsByTagName('link')[0];
            css = document.createElement('link');
            css.href= paths;
            css.rel='stylesheet';
            css.id = id || "";
            type = css;
            break;
        default :
            return;
    }

    if(!callback.done && type.addEventListener) {
        //w3c + IE9 and up
        callback.done = true;
        type.addEventListener("load", callback, false);
    } else if(!callback.done && type.readyState) {
        //IE Legacy
        type.onreadystatechange = function(){
            if(/loaded|complete/.test(type.readyState)){
                callback.done = true;
                type.onreadystatechange = null;
                callback();
            }
        }
    }

    first.parentNode.insertBefore( type, first );
};


illicoweb.utilities = (function($) {
    var browserUA = {
            "msie": "ie",
            "firefox": "ff",
            "chrome": "chr",
            "safari": "saf"
        },
        ua = null,
        shadowTemplate =
            //'<div class="shadow-center">'+'<span class="shadow-left"></span><span class="shadow-right"></span>'+'</div>',
            '<div class="shadow-center"></div>',
        ngRootScope = undefined,//iframe purpose: required for tvguide. The var is set in CtrlMain.js
        intervalVal = 250,//in millisecs / 1/4secs
        timerMax = 3000,//3secs
        timerCounter = 0,
        matched, matchedLength,
        initials,
        minLettersMaxWords = 2,//min letters (2 or more letters) and max words (2 first names/words)

        getBrowser = function(){
            var N=navigator.appName, ua=navigator.userAgent, tem;
            var M=ua.match(/(opera|chrome|safari|firefox|msie)\/?\s*(\.?\d+(\.\d+)*)/i);

            if(M && (tem= ua.match(/version\/([\.\d]+)/i))!= null) M[2]= tem[1];

            M=M? [M[1], M[2]]: [N, navigator.appVersion, '-?'];

            return M[0];
        },

        getBrowserVersion = function() {
            var N=navigator.appName, ua=navigator.userAgent, tem;
            var M=ua.match(/(opera|chrome|safari|firefox|msie)\/?\s*(\.?\d+(\.\d+)*)/i);

            if(M && (tem= ua.match(/version\/([\.\d]+)/i))!= null) M[2]= tem[1];

            M=M? [M[1], M[2]]: [N, navigator.appVersion, '-?'];

            return M[1];
        },

        /**
         * get the name of the browser using its UserAgent
         * @return {String} the name of the browser or null
         * */
        getBrowserName = function() {
            try {
                //chrome: Mozilla/5.0 (Windows NT 5.2; WOW64) AppleWebKit/537.22 (KHTML, like Gecko) Chrome/25.0.1364.172 Safari/537.22
                //ff: Mozilla/5.0 (Windows NT 5.2; WOW64; rv:19.0) Gecko/20100101 Firefox/19.0
                //ie: Mozilla/4.0 (compatible; MSIE 8.0; Windows NT 5.2; WOW64; Trident/4.0; .NET CLR 2.0.50727; .NET CLR 3.0.4506.2152; .NET CLR 3.5.30729; .NET4.0C; .NET4.0E)
                //safari:Mozilla/5.0 (Windows NT 5.2; WOW64) AppleWebKit/534.57.2 (KHTML, like Gecko) Version/5.1.7 Safari/534.57.2
                ua = navigator.userAgent.toLowerCase();
                //console.log(ua);

                for(var i in browserUA) {
//                    console.log(i+" | "+ browserUA[i]);
//                    alert(i+" | "+ browserUA[i]);
//                    console.log("ua.indexOf("+browserUA[i]+"): "+ua.indexOf(browserUA[i]));
                    if(ua.indexOf(i) != -1) return browserUA[i];
                }

                return null;

            } catch(e) { return null; }
        },

        /** set attribute to an element
         * @param {String} elem: the element to add attribute to
         * @param {String} type: name of the attribute
         * @param {String} attr: attribute value
         * */
        addAttribute = function(elem, type, attr) {
//            console.warn('addAttribute::elem: '+elem+' | type: '+type+' | attr: '+attr);
            if($('body').has(elem).length > 0) {
                var el = (elem instanceof jQuery) ? elem : $(elem);
                $(el).attr(type, attr);
            }
        },

        /**
         * create shadow by appending the template
         * @param (String) elemAppendTo: element to append the shadow template to
         * 890px - .banner (section-banner.html)
         * 560px - .player, .player-image, slideshow (zone-image.html, zone-player.html, zone-player-image.html, zone-player-promo.html)
         * 900px - .card  (zone-image.html)
         *
         * NOTE: replacing ng-show/hide by ng-if potentially causes unexpected results in case of calculating the widest node (illicoweb.utilities.addShadow), the node with the largest width. Since directives are executed before Angular bootstrapping, in other words, ng-if conditions are not validated yet when the directive (illico-shadow) is executed, therefore looping through the children of the element (element param passing to the addShadow function) to get the widest node results to the width of the only node available at that moment if other nodes (other children) are bootstrpping with ng-if instead of ng-show/hide
         *      ie.: zone-image.html, zone-slideshow.html, zone-player-image.html
         * */
        addShadow = function(elemAppendTo) {
//            console.warn('addShadow()');
            var $elem,
                newWidth = 0;

            elemAppendTo instanceof jQuery ? $elem = elemAppendTo : $elem = $(elemAppendTo);
//            console.dir($elem.children());
            $elem.children().each(function() {
//                console.warn('newWidth: '+newWidth);
//                console.warn('$(this).width(): '+$(this).width());
                //in case there are more than one child element (chaine-logo in zone-player-image.html), which has a smaller width than the one targeted (player-image)
                if($(this).width() > newWidth) newWidth = $(this).width();
            });

            $elem.append(shadowTemplate);
            $elem.children('.shadow-center').css('width', newWidth);
        },

        /**
         * Change shadow width
         * use case: player resizes dynamically (player format 4:3 - channel ICI-Radio-Canada), called from setPlayerSize in swf.js
         */
        changeShadowWidth = function(el, w) {
//            console.warn('changeShadowWidth('+el+', '+w+')');
            var $elem = el instanceof jQuery ? el : $(el),
                $shadowElem;

            $elem.parent().siblings('.shadow-center').length > 0 ? $shadowElem = $elem.parent().siblings(".shadow-center") : $shadowElem = $elem.siblings('.shadow-center');

            $shadowElem.css("width", w);// : $(el).find("~ div.shadow-center").css("width", w);
        },

        /**
         * Validating input fields of different type (empty, email, date,...)
         * TODO: other than empty to be implemented
         */
        isValid = function(type, value) {
            var valid = false;

            if(type == "text"){
                if(value != "" && value != null && value != undefined) {
                    valid = true;
                }
            }

            return valid;
        },

        /**
         * Show an element by adding visible, and removing invisible and hide classes
         * @param elem: jQuery element selector or element's id
         */
        elemVisible = function(elem) {
//            console.warn('elemVisible()');
            if($('body').has(elem).length > 0) {
                var el = (elem instanceof jQuery) ? elem : $(elem);
                el.removeClass('invisible').removeClass('hide').addClass('visible');
            }
        },

        /**
         * Hide an element by adding invisible, and removing visible and show classes
         * @param elem: jQuery element selector or element's id
         */
        elemInvisible = function(elem) {
//            console.warn('elemInvisible()');
            if($('body').has(elem).length > 0) {
                var el = (elem instanceof jQuery) ? elem : $(elem);
                el.removeClass('show').removeClass('visible').addClass('invisible');
            }
        },

        /**
         * Show an element by adding show, and removing invisible and hide classes
         * @param elem: jQuery element selector or element's id
         */
        elemShow = function(elem) {
//            console.warn('elemShow()');
            if($('body').has(elem).length > 0) {
                var el = (elem instanceof jQuery) ? elem : $(elem);
                el.removeClass('invisible').removeClass('hide').addClass('show');
            }
        },

        /**
         * Hide an element by adding hide, and removing visible and show classes
         * @param elem: jQuery element selector or element's id
         */
        elemHide = function(elem) {
//            console.warn('elemHide()');
            if($('body').has(elem).length > 0) {
                var el = (elem instanceof jQuery) ? elem : $(elem);
                el.removeClass('visible').removeClass('show').addClass('hide');
            }
        },

        /**
         * Toggle element's visibility, display
         * @param elem: jQuery element selector or element's id
         */
        elemToggle = function(elem) {
//            console.log('elemToggle()');
            if($('body').has(elem).length > 0) {
                var el = (elem instanceof jQuery) ? elem : $(elem);
                if(el.hasClass('visible') && el.hasClass('show')) {
                    el.removeClass('visible').removeClass('show').addClass('invisible').addClass('hide');
                } else if(el.hasClass('visible') || el.hasClass('show')) {
                    el.hasClass('visible') ? el.removeClass('visible').addClass('invisible') : el.removeClass('show').addClass('hide');
                } else if(el.hasClass('invisible') && el.hasClass('hide')) {
                    el.removeClass('invisible').removeClass('hide').addClass('visible').addClass('show');
                } else if(el.hacClass('invisible') || el.hasClass('hide')) {
                    el.hasClass('invisible') ? el.removeClass('invisible').addClass('visible') : el.removeClass('hide').addClass('show');
                }
            }
        },

        /**
         * Open a new browser window
         * @param linkNameSpecsReplace
         *          [0] link: url of the new window
         *          [1] name: _blank (default), _self, name of the window,... (optional)
         *          [2] specs: channelmode, left, width, height, menubar, titlebar,... (optional)
         *          [3] replace: true/false - in the history list (optional)
         */
        openWindow = function(args) {
//            console.dir(args);
            window.open(args[0],args[1],args[2],args[3]);
        },

        /**
         * Validate if at end of the string contains another string
         * @param {str} - string from which to be looked in
         * @param {suffix} - string to look for
         */
        endsWith = function(str, suffix) {
            return (str.indexOf(suffix, str.length - suffix.length) !== -1);
        },

        /**
         * Validate if the string contains another string
         * @param {str} - string from which to be looked in
         * @param {sLookFor} - string to look for
         */
        containsWithin = function(str, sLookFor) {
            return (str.toString().indexOf(sLookFor) !== -1);
        },

        /**
         * To execute an expression in angular from outside the angular framework, also to prevent angular digest() problem
         */
        safeApply = function(scope, fn) {
//            console.warn('common::safeApply()');
            var phase = scope.$root.$$phase;
            if(phase == '$apply' || phase == '$digest')
                scope.$eval(fn);
            else
                scope.$apply(fn);
        },

        /**
         * centering an element horz/vert
         */
        elemCentering = function(elem) {
//            console.warn('elemCentering('+elem+')');
            if(elem) {
                timerCounter = 0;
                var elm,
//                    customEvent = new Event("centered"),
                    timer = window.setInterval(function() {
//                        console.warn("elemCentering::timer");
                        elm = (elem instanceof jQuery) ? elem : elem[0] == "#" ? $(elem) : $(elem = "#" + elem);

//                        console.log("elm: ",elm);
//                        console.log("elm.length: ",elm.length);
//                        console.log("elm.height(): ",elm.height());

                        if(elm != null && elm.length > 0 && elm.height() > 0) {
                            window.clearInterval(timer);

                            elm.css({
                                'left':($(window).innerWidth() - elm.width())/2,
                                'top':($(window).innerHeight() - elm.height())/2 < 0 ? 0 : ($(window).innerHeight() - elm.height())/2
                            });

                            //centering success: dispatch custom event
                            $.event.trigger({
                                type: "evtElemCentered"
                            });

                            if(elm.hasClass("invisible")) elm.removeClass("invisible");
                        }

                        timerCounter += intervalVal;

                        //prevent looping infinitely, stops looping after timerMax (3secs max)
                        if(timerCounter >= timerMax) {
                            window.clearInterval(timer);

                            //centering failed: dispatch custom event
                            $.event.trigger({
                                type: "evtElemCenteredFailed"
                            });

                            //console.error("elemCentering failed");
                            //console.error("elm: ",elm);
                            //console.error("elm.length: ",elm.length);
                            //console.error("elm.height(): ",elm.height());
                        }
                    },intervalVal);
            }
        },

        /*modalStorageSet = function(value) {
//            console.warn('modalStorageSet('+value+')');
//            sessionStorage.setItem(COOKIE.MODAL_IN_PROGRESS, value);

            switch(value) {
                case 'connect':
                    localStorage.setItem(COOKIE.MODAL_IN_PROGRESS, value);
//                    sessionStorage.setItem(COOKIE.MODAL_IN_PROGRESS, value);
                    break;
                default:
                    localStorage.setItem(COOKIE.MODAL_TYPE, value);
//                    sessionStorage.setItem(COOKIE.MODAL_TYPE, value);
            }

//            console.warn('>>> '+this.modalStorageGet(COOKIE.MODAL_IN_PROGRESS));
        },

        modalStorageGet = function(value) {
//            console.warn('modalStorageGet('+value+')');
//            return sessionStorage.getItem(COOKIE.MODAL_IN_PROGRESS);

            switch(value) {
                case 'connect':
                    return localStorage.getItem(COOKIE.MODAL_IN_PROGRESS);
//                    return sessionStorage.getItem(COOKIE.MODAL_IN_PROGRESS);
                default:
                    return localStorage.getItem(COOKIE.MODAL_TYPE);
//                    return sessionStorage.getItem(COOKIE.MODAL_TYPE);
            }
        },

        modalStorageRemove = function(value) {
//            console.warn('modalStorageRemove('+value+')');
//            sessionStorage.removeItem(COOKIE.MODAL_IN_PROGRESS);
            switch(value) {
                case 'connect':
                    localStorage.removeItem(COOKIE.MODAL_IN_PROGRESS);
//                    sessionStorage.removeItem(COOKIE.MODAL_IN_PROGRESS);
                    break;
                default:
                    localStorage.removeItem(COOKIE.MODAL_TYPE);
//                    sessionStorage.removeItem(COOKIE.MODAL_TYPE);
            }
        },*/

        /**
         * set focus on the element
         * @param elem
         */
        setFocus = function(elem) {
//            console.warn("setFocus::elem: ",elem);
//            console.log("$('body').has(elem).length > 0: ",$('body').has(elem).length > 0);
            if(elem) {
                timerCounter = 0;
                var elm,
                    timer = window.setInterval(function() {//check the avail of the element, and stop interval once avail
//                        console.log("setFocus()::timer");

                        elm = elem instanceof jQuery ? elem : elem[0] == "#" ? $(elem) : $(elem = "#" + elem);

                        if(elm != null && elm.length > 0 && elm.height() > 0) {
                            window.clearInterval(timer);
                            elm.focus();
                            elm.select();//highlight input
                        }

                        //prevent looping infinitely, stops looping after 3secs max
                        timerCounter += intervalVal;
                        if(timerCounter >= timerMax) {
                            window.clearInterval(timer);
//                            console.log("setFocus failed");
                        }
                    },intervalVal);
            }
        },

        //show/hide semi-transparent bg covering the whole page
        overlayPageBg = function(type, loading) {
//            console.warn('overlayPageBg('+type+', '+loading+')');
            var eOverlay = $('body > #overlay-page-bg');
//            var eOverlay = $('body > .overlay-bg');

            switch(type) {
                case 'hide':
                    this.elemHide(eOverlay);
                    this.elemHide(eOverlay.find('> div'));
//                    this.elemHide(eOverlay.find('.overlay-loading'));
                    break;
                case 'show':
                    this.elemShow(eOverlay);
                    if(loading) this.elemShow(eOverlay.find('> div'));
//                    if(loading) this.elemShow(eOverlay.find('.overlay-loading'));
                    break;
                default:
            }
        },

        //set/unset the highest index (z-index) of an element
        //used in tvguide legacy, this function should be removed once new tvguide implemented, use setLayer() instead
        highestZindex = function(type, elem) {
            if($('body').has(elem).length > 0) {
                var el = (elem instanceof jQuery) ? elem : $(elem);
                type == 'set' ? el.addClass('zindex-highest') : el.removeClass('zindex-highest');
            }
        },

        /**
         * set/unset the layer (z-index high, higher and highest) of an element
         * @param {str/jquery object} - elem: element which the property is applied to
         * @param {str} - layer: high (950), higher (999) and highest (1000)
         * @param {str} - type: set or unset (anything thing other than set)
         */
        setLayer = function(elem, layer, type) {
//            console.warn('setLayer('+elem+', '+layer+', '+type+')');
            if($('body').has(elem).length > 0) {
                var el = (elem instanceof jQuery) ? elem : $(elem);
                type == 'set' ? el.addClass('zindex-'+layer) : el.removeClass('zindex-'+layer);
            }
        },

        /**
         * get the string that follows the delimiter (delim) of the URI (str)
         * TODO: expand the function to get the params and their values
         * ex: http://vl096392.int.videotron.com/films/215435/Monstres-inc?auto=true
         */
        getUriParam = function(str, delim) {
//            console.warn('str: '+str);
//            console.warn('delim: '+delim);
            var indexStart = null,
                indexEnd = str.length;

            indexStart = str.indexOf(delim) + 1;//indicator's start index, next index of the found delimiter index

            if(indexStart != null && indexStart > 0) {
                return str.substring(indexStart, indexEnd);
            }

            return false;//
        },

        /**
         * Replacing a char (charToReplace) by another (charReplaceWith)
         * @param str
         * @param charToReplace
         * @param charReplaceWith
         * @returns {string}
         */
        replaceCharInString = function(str, charToReplace, charReplaceWith) {
            var newStr = "";

            if(str.length > 0) {
                for (var i = -1, j = str.length; ++i < j;) {
                    newStr += str[i].replace(charToReplace, charReplaceWith);
                }
            }

            return newStr;
        },

        /**
         * Replaces a string (strLookFor) by another (strReplaceWith)
         * @param strLookIn
         * @param strLookFor
         * @param strReplaceWith
         * @returns {*}
         */
        replaceStrInStr = function(strLookIn, strLookFor, strReplaceWith) {
//            console.log("strLookIn: ",strLookIn);
//            console.log("strLookFor: ",strLookFor);
//            console.log("replacement: ",strReplaceWith);
            if(strLookIn.indexOf(strLookFor) > 0) {
                return strLookIn.replace(strLookFor, strReplaceWith);
            }

            return strLookIn;
        },

        /**
         * To capitalize a string (first char uppercase)
         * @param str
         */
        capitalized = function(str) {
//            console.log("str: ",str);
//            console.log("commonConstant.capitalized: ",commonConstant.capitalized);
            return str.replace(COMMON_REGEX.capitalized, function(m) {
                return m.toUpperCase();
            })
        };

        //public api
        return {
            browserUA: browserUA,
            getBrowser: getBrowser,
            getBrowserVersion: getBrowserVersion,
            getBrowserName: getBrowserName,
            addAttribute: addAttribute,
            addShadow: addShadow,
            changeShadowWidth: changeShadowWidth,
            isValid: isValid,
            elemVisible: elemVisible,
            elemInvisible: elemInvisible,
            elemShow: elemShow,
            elemHide: elemHide,
            elemToggle: elemToggle,
            openWindow: openWindow,
            endsWith: endsWith,
            containsWithin: containsWithin,
            safeApply: safeApply,
            elemCentering: elemCentering,
//            modalStorageSet: modalStorageSet,
//            modalStorageGet: modalStorageGet,
//            modalStorageRemove: modalStorageRemove,
            setFocus: setFocus,
            overlayPageBg: overlayPageBg,
            highestZindex: highestZindex,//used in tvguide legacy, it will be removed once new tvguide implemented, better use setLayer instead
            setLayer: setLayer,
            getUriParam: getUriParam,
            replaceCharInString: replaceCharInString,
            replaceStrInStr: replaceStrInStr,
            capitalized: capitalized
        }
}(jQuery));

/**
 * common.js-end
 * ***************************/


/**
 * Librairy for DOM manipulation with angularjs or jQuery
 */
illicoweb.dom = (function ($, window, document, undefined) {
    /**
     * Replace element.css form angular library
     * @param element
     * @param styleProp
     * @returns {String}
     */
    var getStyle = function (element, styleProp) {
        var el = (element instanceof window.$) ? element.get(0) : document.getElementById(element);

        if (el.currentStyle)
            var elStyle = el.currentStyle[styleProp];
        else if (window.getComputedStyle)
            var elStyle = document.defaultView.getComputedStyle(el, null).getPropertyValue(styleProp);

        element.attributes

        return elStyle;
    };

    /**
     * Check if the dom element is inner or outer of the viewport.
     * @param element
     * @returns {Boolean}
     */
    var isElementInViewport = function (el) {
        var top = el.offsetTop + el.clientHeight,//
            left = el.offsetLeft + el.clientWidth,//,
            width = el.offsetWidth,
            height = el.offsetHeight;

        while (el.offsetParent) {
            el = el.offsetParent;
            top += el.offsetTop;
            left += el.offsetLeft;
        }

        return (
            top < (window.pageYOffset + window.innerHeight) &&
                left < (window.pageXOffset + window.innerWidth) &&
                (top + height) > window.pageYOffset &&
                (left + width) > window.pageXOffset
            );
    },

    /**
     * Show an element using css class (show)
     * @param el: jQuery or native dom element object
     */
    elemShow = function (el) {
        ((el instanceof jQuery) ? el : $(el)).removeClass('hide').addClass('show');
    },

        /**
         * Hide an element using css class (hide)
         * @param el: jQuery or native dom element object
         */
        elemHide = function (el) {
            ( (el instanceof jQuery) ? el : $(el) ).removeClass('show').addClass('hide');
        };

    //public api
    return {
        getStyle: getStyle,
        isElementInViewport: isElementInViewport,
        elemShow: elemShow,
        elemHide: elemHide
    }
}(jQuery, this, this.document));




"use strict";

/******************************
 * bridgeEnpWeb.js
 *
 * Allows communication between the GrilleHoraireWeb and IllicoWebClient angular projects
 * while following the pattern put in place for communication between the web app and the mobile device
 * in GrilleHoraireWeb, see these modules for more info :
 *  * module("videotron.illico.native-bridge")
 *  * module("videotron.illico.native-bridge-send") in "native-bridge-send-web"
 *  * module("videotron.illico.common.web").service("NativeActions"
 *
 * enpWebBridgeOut and enpWebBridgeIn are global on purpose to follow pattern from native devices
 *
 *
 * Another instance of bridge exists specifically for Android Club sign-up, look for androidBridgeOut
 *
 *
 */

// define local versions to avoid runtime errors
var enpWebBridgeOut = enpWebBridgeOut || {};
var enpWebBridgeIn = enpWebBridgeIn || {};

// called at app init
enpWebBridgeOut.init = function(data, callbackId){
    var configs = {
        currentPlatformOnly : false,                        // used in ios for state of ipad/tv switch
        clientModelVersion : CLIENT_MODEL_VERSION          // used to add version to http headers for illicoService
    };
    enpWebBridgeIn("init", configs, callbackId);
};

// link to new page
enpWebBridgeOut.link = function(data, callbackId){
    if(data.link){
        window.location = data.link.uri;
    }
};

enpWebBridgeOut.trackPageView = function(data){
    //console.info("enpWebBridgeOut.trackPageView", data)
    angular.element(document).injector().get("SrvGoogleAnalytics").trackPageView(data.url, data.title);
};

enpWebBridgeOut.trackEvent = function(data){
    //console.info("enpWebBridgeOut.trackEvent", data)
    angular.element(document).injector().get("SrvGoogleAnalytics").trackEvent(data.category, data.action, data.label);
};


/***
 * bridgeEnpWeb.js-end
 * ***************************/

'use strict';

/****************************************
 * cookie.js
 * handling browser's cookie
 * */
var illicoweb = illicoweb || {};

 illicoweb.cookie = (function($) {
        /**
         * Set cookie
         * - by default (if options not defined), cookie expires at the end of the session, with current path
         * @param key {String} - cookie name
         * @param value {String} - cookie value
         * @param options {object} - expires:10 (10 days), path:'/', domain:'videotron.com', secure:true
         * ex.: setter("survey-count", 1++, {expires:10, path:"/"});
         */
    var setter = function(key, value, options){
//            console.info("cookie::setter(",key,",",value,",",options,")");
            if(typeof arguments[2] == "undefined") options = {};
            if(typeof $.cookie == "function")
                $.cookie(key, value, options);
        },
        /**
         * Get cookie
         * @key {String} - cookie name
         */
        getter = function(key){
            if(typeof $.cookie == "function")
                return $.cookie(key);
        },
        /**
         * Remove cookie
         * @key {String} - cookie name
         */
        remover = function(key){
//            console.info("cookie::remover(",key,")");
            if(typeof $.removeCookie == "function")
                $.removeCookie(key);
        },

        /**
        * @private
         *
        * Retrieve a key value pairs from Cookie (subCookie version)
         *
        * @key {String} - cookie name
        */
        _getAll  = function(name){

            var cookieName = encodeURIComponent(name) + "=",
                cookieStart = document.cookie.indexOf(cookieName),
                cookieValue = null,
                parts,
                result = {};

                if (cookieStart > -1){
                    var cookieEnd = document.cookie.indexOf(";", cookieStart);

                    if (cookieEnd == -1){
                        cookieEnd = document.cookie.length;
                    }

                    cookieValue = document.cookie.substring(cookieStart + cookieName.length, cookieEnd);

                    if (cookieValue.length > 0){
                        var subCookies = cookieValue.split("&");

                        for (var i=0, len=subCookies.length; i < len; i++){
                            parts = subCookies[i].split("=");
                            result[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1]);
                        }

                        return result;
                    }
                }

            return null;
        },

        /**
         * @private
         *
         * Write a subcookie a key value pairs (subCookie version)
         *
         * TODO: Need traverse object func
         *
         * @key {String} - cookie name
         * @key {String} - cookie sub cookie name (key)
         * @key {String} - cookie expires
         * @key {String} - cookie path
         * @key {String} - cookie domaine
         * @key {String} - cookie secure
         */
        _setAll = function(name, subCookies, expires, path, domain, secure){

             var cookieText = encodeURIComponent(name) + "=";
             var subCookieParts = new Array();

             for (var subName in subCookies){
                 if (subName.length > 0 && subCookies.hasOwnProperty(subName)){
                     subCookieParts.push(encodeURIComponent(subName) + "=" + encodeURIComponent(subCookies[subName]));
                 }
             }

             if (subCookieParts.length > 0){

                 cookieText += subCookieParts.join("&");


                 if (typeof expires === "string" || typeof expires === "number") {

                     var date = new Date();
                     date.setTime((date.getTime()+(Number(expires)*24*60*60*1000)));

                     cookieText += "; expires=" + date.toGMTString();

                 }else if(expires instanceof Date) {
                     cookieText += "; expires=" + expires.toGMTString();
                 }

                 if (path) {
                     cookieText += "; path=" + path;
                 }

                 if (domain) {
                     cookieText += "; domain=" + domain;
                 }

                 if (secure) {
                     cookieText += "; secure";
                 }
             } else {
                 cookieText += "; expires=" + (new Date(0)).toGMTString();
             }


             document.cookie = cookieText;
        },

        /**
         * Write a cookie
         *
         * @key {String} - cookie name
         * @key {String} - cookie sub cookie name (key)
         * @key {String} - cookie value
         * */
        setter2 = function(name, subName, value, expires, path, domain, secure){

            var subCookies = _getAll(name) || {};
            subCookies[subName] = value;
            _setAll(name, subCookies, expires, path, domain, secure);
        },

        /**
         * Get a key value pairs from Cookie
         *
         * */
        getter2 = function(name, subName){
            var subCookies = _getAll(name);
            if(subCookies){
                return subCookies[subName];
            }else{
                return null;
            }
        },

        /**
         * Removing a subcookie key value pairs from Cookie
         *
         * */
        unset2 = function (name, subName, path, domain, secure){
             var subcookies = _getAll(name);
             if (subcookies){
                 delete subcookies[subName];
                 _setAll(name, subcookies, null, path, domain, secure);
             }
         },

        /**
         * Removing all key value pairs from Cookie
         *
         * */
         unsetAll2 = function(name, path, domain, secure){
             _setAll(name, null, new Date(0), path, domain, secure);
         },

        //////////////////////////////////////////
        /**
         * cookieVerify
         */
//         cookieVerify = function(cookieName){
//            if($.cookie(cookieName)) return true;
//            else return false;
////            if($.cookie(cookieName)) {
////                $("#username").val($.cookie("session-username"));
////                $("#rememberMe").attr('checked','checked'); //warning if you update jQuery version
////            }
//        },
        /**
         * cookieIsEnabled
         */
        isEnabled = function(){
            var enabled = (navigator.cookieEnabled) ? true : false ;//not a standard API
            if (typeof navigator.cookieEnabled == "undefined" && !enabled){
                document.cookie = "testcookie";
                enabled = (document.cookie.indexOf("testcookie") != -1) ? true : false;
            }
            return enabled;
        }

    //public api
    return {
        setter: setter,
        getter: getter,
        remover: remover,
//        cookieVerify: cookieVerify,
        isEnabled: isEnabled,
        getter2: getter2,
        setter2: setter2,
        unset2: unset2,
        unsetAll2: unsetAll2
    }
})(jQuery);

/**
 * cookie.js-end
 * ****************************/
"use strict";

/******************************
 * illico.js
 */

//DOM ready
var docReady = (function($, illicowebBrowser) {
    $(function() {//same as $(document).ready()
        (function() {
//            console.warn('>>>>>>>>>> DOM - document ready');
//            console.dir(illicowebBrowser);

            if(!illicoweb.cookie.getter(illicowebBrowser.COOKIE) || illicoweb.cookie.getter(illicowebBrowser.COOKIE) == undefined || illicoweb.cookie.getter(illicowebBrowser.COOKIE) == null)
                illicoweb.cookie.setter(illicowebBrowser.COOKIE, illicowebBrowser.name = illicoweb.utilities.getBrowserName(), {path:'/', expires:365});
            else illicowebBrowser.name = illicoweb.cookie.getter(illicowebBrowser.COOKIE);

//            console.log('illicowebBrowser.name: '+illicowebBrowser.name);
            $('body').addClass(illicowebBrowser.name);//add browser name to the body tag - css purposes
        })();
    });
}(jQuery, illicoweb.browser));


/***
 * illico.js-end
 * ***************************/

//Based on custom script provided to Videotron by IMDB
//Could not be wrapped in $http promise as an Angular Service (must use JQuery $.ajax to execute a script JSONP served by IMDB server)

// define local versions to avoid runtime errors
var imdb = imdb  || {};

imdb.rating = {
    htmlSelector : "#jsonpRating", //default html element to target if none injected into function
    getJsonp: function (imdbId, htmlSelector) {

        //console.time("jsonP")
        if(htmlSelector){
            imdb.rating.selector = htmlSelector;
        }

        $.ajax({
            url: "https://p.media-imdb.com/static-content/documents/v1/title/" + imdbId + "/ratings%3Fjsonp=imdb.rating.run:imdb.api.title.ratings/data.json?s=videotron",
            crossDomain: true,
            dataType: 'jsonp'
        });
    },
    run: function (data) {
        //console.log("imdb", data.resource.rating);
        //console.timeEnd("jsonP")
        $(imdb.rating.selector).text(data.resource.rating);
    }
};
/**
 * lightboxHelper.js
 *
 * The lightbox's dimensions can be predefined by calling dimensionDefine() with arguments
 * The lightbox position/alignment are defined automatically by the space's availability around the lightbox's parent, if not predefined when calling positionDefine()
 * The lightbox's positions are: left, right, top and bottom, respectively if not predefined (see common.js - COMMON_LIGHTBOX.position)
 * The lightbox's alignments are: left, right, top, bottom and center (see common.js - COMMON_LIGHTBOX.align)
 *
 * Particularities:
 *      1. the arrow node is outside of the lightbox-wrapper to facilitate its position, notably when the lightbox position is top; the first interaction with the lightbox does not give its exact height in order to positioning the lightbox depending on its height. Not depend on lightbox height to correctly position the arrow height, use the parent node position instead.
 *      2. lightbox bg node (lightbox-bg), if required, needs to be after the lightbox node (lightbox-wrapper), in order to be able to retrieve the correct width and height of the later (ie.: lightbox/confirmation.html) - see lightboxElem below
 *
 */
illicoweb.lightboxHelper = (function($) {
    var DEFAULTS = {
        bg: {
            color: 0,
            opacity: 0.95
        },
        time: {
            delay: 100,
            fadeIn: 400,
            fadeOut: 250
        },
        padding: 15,
        boxShadow: {
            hShadow: '2px ',
            hShadowNeg: '-2px ',
            vShadow: '2px ',
            vShadowNeg: '-2px ',
            blur: '5px ',
            color: '#000'
        }
    };
    var POS = {
        top: 'top',
        right: 'right',
        bottom: 'bottom',
        left: 'left'
    };
    var ARROW_CLASS = {
        up: 'arrow-up',
        right: 'arrow-right',
        down: 'arrow-down',
        left: 'arrow-left'
    };
    var BORDER_COLOR_ATTR = {
        bottom: 'border-bottom-color',
        left: 'border-left-color'
    };

    var windowView = {};
    var lightboxParent = {};
    var lightbox = {};
    var delayTimer;
    var delayTime;
    var fadeInTime;
    var fadeOutTime;
    var arrowTemplate;
    var $arrowTemplate;
    var $lightboxWrapper;//for positioning the lightbox
    var $lightboxContent;//for positioning the arrow
    var isParentWider;

    /**
     * The position is defined automatically, if not predefined, by the space availability around the lightbox's parent; right, left, top and bottom respectively
     * @returns {*}
     */
    function definePosition() {
        var position;

        if(lightboxParent.offset.left - windowView.scrollLeft + lightboxParent.width + lightbox.width <= windowView.innerWidth) position = COMMON_LIGHTBOX.position.right;
        else if(lightboxParent.offset.left - windowView.scrollLeft - lightbox.width >= 0) position = COMMON_LIGHTBOX.position.left;
        else if(lightboxParent.offset.top - windowView.scrollTop - lightbox.height >= 0) position = COMMON_LIGHTBOX.position.top;
        else if(lightboxParent.offset.top - windowView.scrollTop + lightboxParent.height + lightbox.height <= windowView.innerHeight) position = COMMON_LIGHTBOX.position.bottom;
        //console.log('position: ', position);
        return position;
    }

    /**
     * The alignment is defined automatically, if not predefined, by the space availability around the lightbox's parent; center, top or bottom (position: left or right), left or right (position: top or bottom) respectively
     * @returns {*}
     */
    function defineAlignment(position) {
        var alignment;

        if (position === COMMON_LIGHTBOX.position.left || position === COMMON_LIGHTBOX.position.right) {//position: left/right
            if ((lightboxParent.offset.top + (lightboxParent.height/2) + (lightbox.height/2) <= windowView.innerHeight)
                && (lightboxParent.offset.top + (lightboxParent.height/2) - (lightbox.height/2) >= 0)) {//alignment: center
                alignment = COMMON_LIGHTBOX.align.center;
            } else if (lightboxParent.offset.top + lightbox.height <= windowView.innerHeight) {//alignment: top
                alignment = COMMON_LIGHTBOX.align.top;
            } else if (lightboxParent.offset.top + lightboxParent.height - lightbox.height >= 0) {//alignment: bottom
                alignment = COMMON_LIGHTBOX.align.bottom;
            }
        } else {//position: top/bottom
            if ((lightboxParent.offset.left + (lightboxParent.width/2) - (lightbox.width/2) >= 0)
                && (lightboxParent.offset.left + (lightboxParent.width/2) + (lightbox.width/2) <= windowView.innerWidth)) {//alignment: center
                alignment = COMMON_LIGHTBOX.align.center;
            } else if (lightboxParent.offset.left + lightbox.width <= windowView.innerWidth) {//alignment: left
                alignment = COMMON_LIGHTBOX.align.left;
            } else if (lightboxParent.offset.left + lightboxParent.width - lightbox.width >= 0) {//alignment: right
                alignment = COMMON_LIGHTBOX.align.right;
            }
        }
        //console.log('alignment: ', alignment);
        return alignment;
    }

    function getArrowObj(position, align) {
        //console.log('getArrowObj()');
        var arrowObj = {
            x: {},
            y: {}
        };

        if (position === COMMON_LIGHTBOX.position.top || position === COMMON_LIGHTBOX.position.bottom) {//position: top/bottom
            arrowObj.width = 20;
            arrowObj.height = 10;
            arrowObj.border = BORDER_COLOR_ATTR.bottom;
            arrowObj.y.pos = POS.top;

            if(position === COMMON_LIGHTBOX.position.top) {
                arrowObj.class = ARROW_CLASS.down;
                arrowObj.y.value = $lightboxWrapper.height();
            } else {//bottom
                arrowObj.class = ARROW_CLASS.up;
                arrowObj.y.value = -(arrowObj.height);
            }

            switch(align) {
                case COMMON_LIGHTBOX.align.center:
                    arrowObj.x.pos = POS.left;

                    if (isParentWider) {
                        arrowObj.x.value = $lightboxWrapper.width() - (lightbox.width/2) + (arrowObj.width/2);
                    } else {
                        arrowObj.x.value = ($lightboxWrapper.width()/2) - (arrowObj.width/2);
                    }

                    break;
                case COMMON_LIGHTBOX.align.left:
                    arrowObj.x.pos = POS.left;
                    arrowObj.x.value = (lightboxParent.width/2) - (arrowObj.width/2);
                    break;
                case COMMON_LIGHTBOX.align.right:
                    arrowObj.x.pos = POS.right;
                    arrowObj.x.value = (lightboxParent.width/2) - (arrowObj.width/2);
                    break;
                default:
            }
        } else {//position: left/right
            arrowObj.width = 10;
            arrowObj.height = 20;
            arrowObj.border = BORDER_COLOR_ATTR.left;
            arrowObj.x.value = -(arrowObj.width);

            if(position === COMMON_LIGHTBOX.position.left) {
                arrowObj.class = ARROW_CLASS.right;
                arrowObj.x.pos = POS.right;
            } else {//right
                arrowObj.class = ARROW_CLASS.left;
                arrowObj.x.pos = POS.left;
            }

            switch(align) {
                case COMMON_LIGHTBOX.align.center:
                    arrowObj.y.pos = POS.top;
                    arrowObj.y.value = ($lightboxWrapper.height()/2) - (arrowObj.height/2);
                    break;
                case COMMON_LIGHTBOX.align.top:
                    arrowObj.y.pos = POS.top;
                    arrowObj.y.value = (lightboxParent.height/2) - (arrowObj.height/2);
                    break;
                case COMMON_LIGHTBOX.align.bottom:
                    arrowObj.y.pos = POS.bottom;
                    arrowObj.y.value = (lightboxParent.height/2) - (arrowObj.height/2);
                    break;
                default:
            }
        }

        return arrowObj;
    }

    /**
     * Positioning the lightbox
     */
    function getLightboxObj (position, align) {
        //console.log('getLightboxObj()');
        var lightboxObj = {
            x: {},
            y: {}
        };

        if (position === COMMON_LIGHTBOX.position.top || position === COMMON_LIGHTBOX.position.bottom) {
            lightboxObj.y.pos = POS.top;

            if (isParentWider) {
                parentWiderHandler();
            }

            if (position === COMMON_LIGHTBOX.position.top) {
                lightboxObj.y.value = -($lightboxWrapper.height() + DEFAULTS.padding);
                lightboxObj.padding = '0 0 ' + DEFAULTS.padding + 'px 0';
                switch (align) {
                    case COMMON_LIGHTBOX.align.center:
                    case COMMON_LIGHTBOX.align.left:
                        lightboxObj.boxShadow = DEFAULTS.boxShadow.hShadow +  DEFAULTS.boxShadow.vShadowNeg + DEFAULTS.boxShadow.blur + DEFAULTS.boxShadow.color;
                        break;
                    case COMMON_LIGHTBOX.align.right:
                        lightboxObj.boxShadow = DEFAULTS.boxShadow.hShadowNeg +  DEFAULTS.boxShadow.vShadowNeg + DEFAULTS.boxShadow.blur + DEFAULTS.boxShadow.color;
                        break;
                    default:
                }
            } else {//bottom
                lightboxObj.y.value = lightboxParent.height;
                lightboxObj.padding = DEFAULTS.padding + 'px 0 0';
                switch (align) {
                    case COMMON_LIGHTBOX.align.center:
                    case COMMON_LIGHTBOX.align.left:
                        lightboxObj.boxShadow = DEFAULTS.boxShadow.hShadow +  DEFAULTS.boxShadow.vShadow + DEFAULTS.boxShadow.blur + DEFAULTS.boxShadow.color;
                        break;
                    case COMMON_LIGHTBOX.align.right:
                        lightboxObj.boxShadow = DEFAULTS.boxShadow.hShadowNeg +  DEFAULTS.boxShadow.vShadow + DEFAULTS.boxShadow.blur + DEFAULTS.boxShadow.color;
                        break;
                    default:
                }
            }

            switch (align) {
                case COMMON_LIGHTBOX.align.center:
                    lightboxObj.x.pos = POS.left;

                    if (isParentWider) {
                        lightboxObj.x.value = 0;
                    } else {
                        lightboxObj.x.value = (lightboxParent.width/2) - ($lightboxWrapper.width()/2);
                    }
                    break;
                case COMMON_LIGHTBOX.align.left:
                    lightboxObj.x.pos = POS.left;
                    lightboxObj.x.value = 0;
                    break;
                case COMMON_LIGHTBOX.align.right:
                    lightboxObj.x.pos = POS.right;
                    lightboxObj.x.value = 0;
                    break;
                default:
            }
        } else {//position: left/right
            lightboxObj.x.pos = POS.left;

            if (position === COMMON_LIGHTBOX.position.left) {
                lightboxObj.x.value = -($lightboxWrapper.width() + DEFAULTS.padding);
                lightboxObj.padding = '0 ' + DEFAULTS.padding + 'px 0 0';
                if (align === COMMON_LIGHTBOX.align.bottom) {
                    lightboxObj.boxShadow = DEFAULTS.boxShadow.hShadowNeg +  DEFAULTS.boxShadow.vShadowNeg + DEFAULTS.boxShadow.blur + DEFAULTS.boxShadow.color;
                } else {
                    lightboxObj.boxShadow = DEFAULTS.boxShadow.hShadowNeg +  DEFAULTS.boxShadow.vShadow + DEFAULTS.boxShadow.blur + DEFAULTS.boxShadow.color;
                }
            } else {//right
                lightboxObj.x.value = lightboxParent.width;
                lightboxObj.padding = '0 0 0 ' + DEFAULTS.padding + 'px';
                if(align === COMMON_LIGHTBOX.align.bottom) {
                    lightboxObj.boxShadow = DEFAULTS.boxShadow.hShadow +  DEFAULTS.boxShadow.vShadowNeg + DEFAULTS.boxShadow.blur + DEFAULTS.boxShadow.color;
                } else {
                    lightboxObj.boxShadow = DEFAULTS.boxShadow.hShadow +  DEFAULTS.boxShadow.vShadow + DEFAULTS.boxShadow.blur + DEFAULTS.boxShadow.color;
                }
            }

            switch (align) {
                case COMMON_LIGHTBOX.align.center:
                    lightboxObj.y.pos = POS.top;
                    lightboxObj.y.value = -(($lightboxWrapper.height()/2) - (lightboxParent.height/2));
                    break;
                case COMMON_LIGHTBOX.align.top:
                    lightboxObj.y.pos = POS.top;
                    lightboxObj.y.value = 0;
                    break;
                case COMMON_LIGHTBOX.align.bottom:
                    lightboxObj.y.pos = POS.bottom;
                    lightboxObj.y.value = 0;
                    break;
                default:
            }
        }

        return lightboxObj;
    }

    /**
     * Set the lightbox wrapper to its parent's width when hte later is bigger, which prevents the lightbox to close when hover. Also align the lightbox to the right
     */
    function parentWiderHandler() {
        $lightboxWrapper.css('width', lightboxParent.width);
        $lightboxWrapper.addClass('row');
        $lightboxContent.css('width', lightbox.width);
        $lightboxContent.css('float', 'right');
    }
    /**
     * Remove all style properties, at lightbox closing, to start fresh, in cases where the same lightbox changes position due to window view gets smaller or bigger, thus the position gets changed.
     * @returns {{top: string, right: string, bottom: string, left: string, padding: string, width: string, border: string, float: string, -moz-box-shadow: string, -webkit-box-shadow: string, box-shadow: string, background-color: string}}
     */
    function resetStyleProp () {
        var propObj = {
            'top': '',
            'right': '',
            'bottom': '',
            'left': '',
            'padding': '',
            'width': '',
            'height': '',
            'border': '',
            'float': '',
            '-moz-box-shadow': '',
            '-webkit-box-shadow': '',
            'box-shadow': '',
            'background-color': ''
        };

        return propObj;
    }
    /**
     * Return all 'arrow-' classes to be removed, at lightbox closing, to start fresh, in cases where the same lightbox changes position due to window view gets smaller or bigger, thus the arrow direction gets changed.
     * @param classes
     * @returns {string}
     */
    function getArrowClasses (classes) {
        var tobeRemoved = '';
        for (var k in ARROW_CLASS) {
            if (classes.match(ARROW_CLASS[k])) {
                tobeRemoved += ARROW_CLASS[k] + ' ';
            }
        }

        return tobeRemoved;
    }


    var service = {
        init: function(parent, template, inOptions) {
            //console.log('init()');
            var bg;
            var bgObj;
            var position;
            var alignment;
            var arrowObj;
            var lightboxObj;

            delayTime = inOptions.delayTime != null || inOptions.delayTime != undefined ? inOptions.delayTime : DEFAULTS.time.delay;
            fadeInTime = inOptions.fadeInTime != null || inOptions.fadeInTime != undefined ? inOptions.fadeInTime : DEFAULTS.time.fadeIn;
            fadeOutTime = inOptions.fadeOutTime != null || inOptions.fadeOutTime != undefined ? inOptions.fadeOutTime : DEFAULTS.time.fadeOut;

            windowView = {
                innerWidth: $(window).innerWidth(),
                innerHeight: $(window).innerHeight(),
                scrollTop: $(window).scrollTop(),
                scrollLeft: $(window).scrollLeft()
            };

            lightboxParent = {
                offset: parent.offset(),
                width: parent.width(),
                height: parent.height()
            };

            $lightboxWrapper = $(template);
            $lightboxContent = $lightboxWrapper.children('.lightbox-content');
            arrowTemplate = '<div class="arrow"></div>';

            bgObj = {
                color: inOptions.bg.color != null || inOptions.bg.color != undefined ? inOptions.bg.color : DEFAULTS.bg.color,
                opacity: inOptions.bg.opacity != null || inOptions.bg.opacity != undefined ? inOptions.bg.opacity : DEFAULTS.bg.opacity
            };
            bg = 'rgba('+bgObj.color+', '+bgObj.color+', '+bgObj.color+', '+bgObj.opacity+')';

            //background color predefined
            $lightboxContent.css('background-color', bg);

            if($lightboxContent.find('.arrow').length == 0) $lightboxContent.prepend(arrowTemplate);

            $arrowTemplate = $lightboxContent.children('.arrow');

            if(inOptions.width) {
                lightbox.width = inOptions.width;
                $lightboxContent.css('width', inOptions.width);
            } else {
                lightbox.width = template.width();
            }

            if(inOptions.height) {
                lightbox.height = inOptions.height;
                $lightboxContent.css('height', inOptions.height);
            } else {
                lightbox.height = template.height();
            }

            //to have the lightbox stays opened when hover, even the later is smaller than its parent
            isParentWider = lightboxParent.width > $lightboxWrapper.width();

            position = inOptions.position ? inOptions.position : definePosition();
            alignment = inOptions.align ? inOptions.align : defineAlignment(position);
            //console.log('position:', position);
            //console.log('alignment:', alignment);

            //positioning the arrow
            arrowObj = getArrowObj(position, alignment);
            $arrowTemplate
                .addClass(arrowObj.class)
                .css(arrowObj.x.pos, arrowObj.x.value)
                .css(arrowObj.y.pos, arrowObj.y.value)
                .css(arrowObj.border, bg);

            //positioning the lightbox
            lightboxObj = getLightboxObj(position, alignment);
            $lightboxWrapper
                .css('padding', lightboxObj.padding)
                .css(lightboxObj.x.pos, lightboxObj.x.value)
                .css(lightboxObj.y.pos, lightboxObj.y.value);

            $lightboxContent.css('-webkit-box-shadow', lightboxObj.boxShadow);
            $lightboxContent.css('-moz-box-shadow', lightboxObj.boxShadow);
            $lightboxContent.css('box-shadow', lightboxObj.boxShadow);
        },

        //delay showing the tooltip to avoid multiple hover
        delayStart: function() {
            //console.log('delayStart()');
            delayTimer = setTimeout(function() {
                if($lightboxWrapper) $lightboxWrapper.stop(true, true).fadeIn(fadeInTime);
            }, delayTime);
        },

        //cancel showing the tooltip, if rapidly hover by, by clearing the timer
        delayStop: function() {
            //console.log('delayStop()');
            clearTimeout(delayTimer);
            //fade only if tooltip is showing
            if($lightboxWrapper && $lightboxWrapper.css("display") == "block") {
                $lightboxWrapper
                    .stop(true, true)
                    .fadeOut(fadeOutTime, function () {
                        $lightboxWrapper.css(resetStyleProp());
                        $lightboxContent.css(resetStyleProp());
                        $arrowTemplate
                            .css(resetStyleProp())
                            .removeClass(function (i, classes) {
                                return getArrowClasses(classes);
                            });
                    });
            }
        }
    };

    return service;
}(jQuery));
"use strict";

/********************************************
 * slideHelper.js
 *
 * Show/hide 2 elements, a short and a long description (synopsis), using jQuery animate().
 * Creating the sliding up/down effect using short/long element's height.
 * - init() is called from illicoSlideToggle.js event listener - $on(EVT.contentLoaded...), the dispatched event emitted from CtrlContent.js
 * Note: used in view-content.html
 *
 * */
illicoweb.slideHelper = (function($) {
    var shortDesc = null,
        elemHeightShort = null,
        elemHeightLong = null,
        elemStateCollapsed = true,//always collapsed state if shortDesc exists
        $elemAnim = null,//wrapper desc for animation
        $elemShort = null,//synopsis court
        $elemLong = null,//synopsis long
        $btnToggle = null,//btn for sliding animation
        $btnToggleLabel = null,
        btnToggleTxtExpand = null,//btn expand txt
        btnToggleTxtCollapse = null;//btn collapse txt

    /**
     * show the content's description and setup all the required elements
     * @param content
     * @param elem
     * @param attr
     */
    function init(content, elem, attr) {
//        console.warn('illicoweb.slideHelper.init()');
        shortDesc = content.shortDescription;//console.warn("shortDesc: "+shortDesc);
        $elemAnim = $(elem).find("> div");
        $elemShort = $elemAnim.find("> p");
        $elemLong = $elemAnim.find("> div");
        $btnToggle = $(elem).find("> #"+attr.idSlideToggle);
        $btnToggleLabel = $btnToggle.find('> span');
        btnToggleTxtExpand = attr.labelExpand;
        btnToggleTxtCollapse = attr.labelCollapse;

        //show the initial description, short desc if exists, plus show buttons and /bind actions to them (only if short desc exists)
        if(shortDesc) {
            $elemLong.hide();
            this.btnAction();
        }
        else {
            $elemShort.hide();
            $btnToggle.hide();
        }

        $(elem).removeClass('invisible');
    }

    /**
     * binding actions for sliding purposes
     */
    function btnAction() {
        $btnToggle.on('click', function(e) {
//            console.warn('$elemShort.height(): '+$elemShort.height());
//            console.warn('$elemLong.height(): '+$elemLong.height());
            elemHeightLong = $elemLong.height();
            elemHeightShort = $elemShort.height();

            $elemAnim.animate({
                    height: elemStateCollapsed ? elemHeightLong : elemHeightShort
                }, {
                    duration: 1000,
                    start: function(e) {
                        if(elemStateCollapsed) {
                            $elemShort.hide();
                            $elemLong.show();
                        }
                    },
                    done: function(e) {},
                    complete: function(e) {
                        if(elemStateCollapsed) {//collapsed state (short)
                            $btnToggleLabel.text(btnToggleTxtCollapse);//collapse txt since it's now in expanded state
                            elemStateCollapsed = false;
                        } else {//expanded state (long)
                            $btnToggleLabel.text(btnToggleTxtExpand);//expanded txt since it's now in collapsed state
                            $elemShort.show();
                            $elemLong.hide();
                            elemStateCollapsed = true;
                        }
                    }
                }
            );
        });
    }

    //public api
    return {
        init: init,
        btnAction: btnAction
    };

})(jQuery);

/**
 * slideHelper.js-end
 * ***************************************/
"use strict";

/********************************************
 * tooltipHelper.js
 * Show extra information in tooltip
 *  - tooltip element added once and using display css property to toggle its display
 *  - work closely with the tooltip's properties style (tooltip.scss)
 *  - tooltip's placement can be: left, top, right or bottom, relatively to its parent and page's edges
 *
 * */
illicoweb.tooltipHelper = (function($) {
    var win = null, sc = null, elem = null, tt = null, measurement = {}, position = {}, settings = {}, delayTimer, delayTime, fadeInTime, fadeOutTime, $siteContentWrapper,

        //set initial values
        init = function(window, scope, element, tooltip) {
//            console.log('init');
            win = window;
            sc = scope;
            elem = element;
            tt = tooltip;
            delayTimer = 0;
            delayTime = 400;
            fadeInTime = 400;
            fadeOutTime = 250;
            settings = {
                elemBorder: elem.find(".thumbn-image-image > span"),
                elemBorderClassLeave: "thumbn-leave",
                elemBorderClassEnter: "thumbn-enter",
                padd:12,//padding value between tooltip and href element
                ttChild: tt.children(":first-child"),
                ttArrow: tt.children(":first-child").children(":first-child"),
                ttShadowDist:10,//shadow blur distance
                ttBorder:"1px",
                ttArrowPos:"-14px",
                ttBorderColor:"#fed602"
            };
            $siteContentWrapper = $('#site_content_wrapper');
        },

        setPlacement = function() {
            measurement = {
//                winWidthMiddle:win.innerWidth,//1.2
//                winHeight:win.innerHeight,//1.2
                winWidthMiddle:$(win).innerWidth()/2,//1.9
                winHeight:$(win).innerHeight(),//1.9
                pageYOffset: win.scrollY || win.pageYOffset || $(win).scrollTop(),
                pageWidthMiddle: $("header").width()/2,
                elemTop: $siteContentWrapper.length != 0 && $siteContentWrapper.hasClass("pos-relative") ? $siteContentWrapper.offset().top + elem.parent().position().top : elem.parent().position().top,
                elemLeft: elem.parent().position().left,
                elemWidth: elem.width(),
                elemHeight: elem.height(),
                elemWidthMiddle: elem.width()/2,
                elemHeightMiddle: elem.height()/2,
                ttWidth: tt.width(),
                ttHeight: tt.height(),
                ttWidthMiddle: tt.width()/2,
                ttHeightMiddle: tt.height()/2,
                maxTop: 0,
//                maxBottom:win.innerHeight//1.2
                maxBottom:$(win).innerHeight()//1.9
            };
//            console.warn('measurement: ',measurement);

            position = {
                placement: null,
                maxLeft: measurement.winWidthMiddle - measurement.pageWidthMiddle,
                maxTop: 0,
                maxRight: measurement.winWidthMiddle + measurement.pageWidthMiddle,
                maxBottom: measurement.winHeight,
                vertLeft: measurement.elemLeft + measurement.elemWidthMiddle - measurement.ttWidthMiddle - settings.ttShadowDist - settings.padd,
                vertTop: measurement.elemTop - measurement.pageYOffset + measurement.elemHeightMiddle - measurement.ttHeightMiddle,
                vertRight: measurement.elemLeft + measurement.elemWidthMiddle + measurement.ttWidthMiddle + settings.ttShadowDist + settings.padd,
                vertBottom: measurement.elemTop  - measurement.pageYOffset + measurement.elemHeightMiddle + measurement.ttHeightMiddle + settings.ttShadowDist,
                horzRight: measurement.elemLeft + measurement.elemWidth + measurement.ttWidth + settings.ttShadowDist + settings.padd
            };
//            console.log('position: ',position);

            if(position.vertTop < position.maxTop || position.vertBottom > position.maxBottom) {//tooltip's placement: top or bottom
                if(position.vertTop < position.maxTop) {//bottom
                    if(position.vertRight > position.maxRight) {
                        position.placement = "bottom-align-right";
                    } else if(position.vertLeft < position.maxLeft) {
                        position.placement = "bottom-align-left";
                    } else {
                        position.placement = "bottom-center";
                    }
                } else {//top
                    if(position.vertRight > position.maxRight) {
                        position.placement = "top-align-right";
                    } else if(position.vertLeft < position.maxLeft) {
                        position.placement = "top-align-left";
                    } else {
                        position.placement = "top-center";
                    }
                }
            } else {//tooltip's placement: left or right
                if(position.horzRight < position.maxRight) {
                    position.placement = "right";
                } else {
                    position.placement = "left";
                }
            }
//            console.warn("placement: "+position.placement);
            return position.placement;
        },

        //define tooltip's placement and its graphic assets (shadow, arrow, border,...)
        setVisual = function(placement) {
            var newValue = {},
                boxShadow = {
                    color: "#111",
                    blurSpread: "10px 0"
                };

            switch(placement){
                case "right":
                    newValue = {
                        ttPosLeft: measurement.elemWidth,
                        ttPosTop: measurement.elemHeightMiddle - measurement.ttHeightMiddle,
                        ttArrowX: "left",
                        ttArrowY: "top",
                        ttArrowPos: measurement.ttHeightMiddle - (settings.ttArrow.height()/2),
                        ttArrowClass: "icon-arrow-left",
                        ttBorder: "border-left-width",
                        ttShadow: "5px 5px " + boxShadow.blurSpread + boxShadow.color,
                        ttPadd: "padding-left"
                    };
                    break;
                case "left":
                    newValue = {
                        ttPosLeft:  -(measurement.ttWidth + settings.padd),
                        ttPosTop: measurement.elemHeightMiddle - measurement.ttHeightMiddle,
                        ttArrowX: "right",
                        ttArrowY: "top",
                        ttArrowPos: measurement.ttHeightMiddle - (settings.ttArrow.height()/2),
                        ttArrowClass: "icon-arrow-right",
                        ttBorder: "border-right-width",
                        ttShadow: "-5px 5px " + boxShadow.blurSpread + boxShadow.color,
                        ttPadd: "padding-right"
                    };
                    break;
                case "bottom-align-right":
                    newValue = {
                        ttPosLeft: -(measurement.ttWidth - measurement.elemWidth),
                        ttPosTop: measurement.elemHeight,
                        ttArrowX: "top",
                        ttArrowY: "left",
                        ttArrowPos: measurement.ttWidth - (measurement.elemWidthMiddle + (settings.ttArrow.height()/2)),
                        ttArrowClass: "icon-arrow-top",
                        ttBorder: "border-top-width",
                        ttShadow: "-5px 5px " + boxShadow.blurSpread + boxShadow.color,
                        ttPadd: "padding-top"
                    };
                    break;
                case "bottom-align-left":
                    newValue = {
                        ttPosLeft: 0,
                        ttPosTop: measurement.elemHeight,
                        ttArrowX: "top",
                        ttArrowY: "left",
                        ttArrowPos: measurement.elemWidthMiddle - (settings.ttArrow.height()/2),
                        ttArrowClass: "icon-arrow-top",
                        ttBorder: "border-top-width",
                        ttShadow: "5px 5px " + boxShadow.blurSpread + boxShadow.color,
                        ttPadd: "padding-top"
                    };
                    break;
                case "bottom-center":
                    newValue = {
                        ttPosLeft: measurement.elemWidthMiddle - measurement.ttWidthMiddle,
                        ttPosTop: measurement.elemHeight,
                        ttArrowX: "top",
                        ttArrowY: "left",
                        ttArrowPos: measurement.ttWidthMiddle - (settings.ttArrow.height()/2),
                        ttArrowClass: "icon-arrow-top",
                        ttBorder: "border-top-width",
                        ttShadow: "0 5px " + boxShadow.blurSpread + boxShadow.color,
                        ttPadd: "padding-top"
                    };
                    break;
                case "top-align-right":
                    newValue = {
                        ttPosLeft: -(measurement.ttWidth - measurement.elemWidth),
                        ttPosTop:  -(measurement.ttHeight + settings.padd),
                        ttArrowX: "bottom",
                        ttArrowY: "left",
                        ttArrowPos: measurement.ttWidth - (measurement.elemWidthMiddle + (settings.ttArrow.height()/2)),
                        ttArrowClass: "icon-arrow-bottom",
                        ttBorder: "border-bottom-width",
                        ttShadow: "-5px -5px " + boxShadow.blurSpread + boxShadow.color,
                        ttPadd: "padding-bottom"
                    };
                    break;
                case "top-align-left":
                    newValue = {
                        ttPosLeft: 0,
                        ttPosTop: -(measurement.ttHeight + settings.padd),
                        ttArrowX: "bottom",
                        ttArrowY: "left",
                        ttArrowPos: measurement.elemWidthMiddle - (settings.ttArrow.height()/2),
                        ttArrowClass: "icon-arrow-bottom",
                        ttBorder: "border-bottom-width",
                        ttShadow: "5px -5px " + boxShadow.blurSpread + boxShadow.color,
                        ttPadd: "padding-bottom"
                    };
                    break;
                case "top-center":
                    newValue = {
                        ttPosLeft: measurement.elemWidthMiddle - measurement.ttWidthMiddle,
                        ttPosTop: -(measurement.ttHeight + settings.padd),
                        ttArrowX: "bottom",
                        ttArrowY: "left",
                        ttArrowPos: measurement.ttWidthMiddle - (settings.ttArrow.height()/2),
                        ttArrowClass: "icon-arrow-bottom",
                        ttBorder: "border-bottom-width",
                        ttShadow: "0 -5px " + boxShadow.blurSpread + boxShadow.color,
                        ttPadd: "padding-bottom"
                    };
                    break;
                default:
            }

            //set the border (left or right) and the shadow
            settings.ttChild
                .removeAttr("style")//reset style
                .css(newValue.ttBorder, settings.ttBorder)
                .css("box-shadow", newValue.ttShadow);

            //set the arrow and its position
            settings.ttArrow
                .removeAttr("class")
                .addClass(newValue.ttArrowClass)
                .removeAttr("style")//reset style
                .css(newValue.ttArrowX, settings.ttArrowPos)
                .css(newValue.ttArrowY, newValue.ttArrowPos);

            //set the tooltip position
            tt
                .removeAttr("style")//reset style
                .css("left", newValue.ttPosLeft)
                .css("top", newValue.ttPosTop)
                .css(newValue.ttPadd, settings.padd)
                .bind("mouseenter", function(){
                    sc.$apply(enter);
                })
                .bind("mouseleave", function(){
                    sc.$apply(leave);
                });
        },

        //change border color and remove bg image
        enter = function() {
            settings.elemBorder
                .removeAttr("class")
                .addClass(settings.elemBorderClassEnter);
        },

        //change border color and add bg image
        leave = function() {
            settings.elemBorder
                .removeAttr("class")
                .addClass(settings.elemBorderClassLeave);
        },

        //delay showing the tooltip to avoid multiple hover
        setDelay = function() {
            delayTimer = setTimeout(function() {
                tt.fadeIn(fadeInTime);
            }, delayTime);
        },

        //cancel showing the tooltip, if rapidly hover by, by clearing the timer
        stopDelay = function() {
            clearTimeout(delayTimer);

            //fade only if tooltip is showing
            if(tt && tt.css("display") == "block") tt.fadeOut(fadeOutTime);
        };

        return {
            init: init,
            setPlacement: setPlacement,
            setVisual: setVisual,
            enter: enter,
            leave: leave,
            setDelay: setDelay,
            stopDelay: stopDelay
        }
})(jQuery);

/***
 * tooltipHelper.js-end
 * ***************************************/



//# sourceMappingURL=tools.min.js.map